import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@/services/analytics";
import {
	checklist_visualizar,
	despesa_historico_visualizar,
	despesa_relatorio_visualizar,
	despesa_visualizar,
	formulario_lista_visualizar,
	formulario_novo_visualizar,
	home_visualizar,
	landing_visualizar,
	login_visualizar,
	motorista_visualizar,
	pergunta_lista_visualizar,
	pergunta_novo_visualizar,
	rastreamento_visualizar,
	usuario_visualizar,
	veiculo_visualizar,
	vistoria_visualizar,
} from "@/services/analytics/events";

const routeToViewEvent: Record<string, () => void> = {
	"/inspections": vistoria_visualizar,
	"/forms/list": formulario_lista_visualizar,
	"/forms/new": formulario_novo_visualizar,
	"/questions/list": pergunta_lista_visualizar,
	"/questions/new": pergunta_novo_visualizar,
	"/vehicles": veiculo_visualizar,
	"/drivers": motorista_visualizar,
	"/users": usuario_visualizar,
	"/tracking": rastreamento_visualizar,
	"/checklist": checklist_visualizar,
	"/expenses": despesa_visualizar,
	"/expenses/reports": despesa_relatorio_visualizar,
	"/expenses/history": despesa_historico_visualizar,
	"/home": home_visualizar,
	"/login": login_visualizar,
	"/": landing_visualizar,
};

const routeTitles: Record<string, string> = {
	"/inspections": "Vistorias",
	"/forms/list": "Formulários - Lista",
	"/forms/new": "Formulários - Novo",
	"/questions/list": "Perguntas - Lista",
	"/questions/new": "Perguntas - Nova",
	"/vehicles": "Veículos",
	"/drivers": "Motoristas",
	"/users": "Usuários",
	"/tracking": "Rastreamento",
	"/checklist": "Checklist",
	"/expenses": "Despesas",
	"/expenses/reports": "Despesas - Relatórios",
	"/expenses/history": "Despesas - Histórico",
	"/home": "Home",
	"/login": "Login",
	"/": "Início",
};

function getPageTitle(pathname: string): string {
	const basePath = pathname.split("?")[0];
	return routeTitles[basePath] || "Página";
}

export function AnalyticsTracker() {
	const location = useLocation();

	useEffect(() => {
		const { pathname, search } = location;
		const fullPath = search ? `${pathname}${search}` : pathname;
		const basePath = pathname.split("?")[0];
		const pageTitle = getPageTitle(pathname);

		trackPageView(fullPath, pageTitle);

		const viewEvent = routeToViewEvent[basePath];
		if (viewEvent) {
			viewEvent();
		}
	}, [location]);

	return null;
}

export default AnalyticsTracker;
